import { Text } from 'foundations-components/components/Text';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import unescapedText from 'I18n/utils/unescapedText';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useGates } from '../../hooks/useGates';
import { getDefaultSearchTab } from '../../search-bar/utils/getDefaultSearchTab';
import { useCollectionQuery } from '../../search-results/hooks/useCollectionQuery';
import { useSearchResultsPageMetadata } from '../../search-results/hooks/useSearchResultsPageMetadata';
import { MarketplaceLinkParser } from '../MarketplaceLinkParser';
import { UnifiedHeader } from './UnifiedHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function SearchResultsPageHeader() {
  var _params$get, _collectionResult$dat;
  const gates = useGates();
  const collectionResult = useCollectionQuery();
  const isCollection = !!collectionResult.data;
  const {
    heading
  } = useSearchResultsPageMetadata();
  const params = useSearchParams();
  const defaultTab = (_params$get = params.get('tab', {
    allowedValues: ['products', 'solutionsPartners']
  })) !== null && _params$get !== void 0 ? _params$get : getDefaultSearchTab();
  const collectionDescription = (_collectionResult$dat = collectionResult.data) === null || _collectionResult$dat === void 0 ? void 0 : _collectionResult$dat.description;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UnifiedHeader, {
      dataTestId: "search-page-header",
      backBreadcrumb: !isCollection,
      title: heading,
      subtitle: collectionDescription ? /*#__PURE__*/_jsx(MarketplaceLinkParser, {
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          typography: "body-100",
          children: /*#__PURE__*/_jsx(SanitizedText, {
            body: collectionDescription,
            WrapperComponent: "span"
          })
        })
      }) : undefined,
      pathKey: isCollection ? 'FEATURED_COLLECTION' : 'SEARCH_RESULTS'
    }), gates.solutionsSpringSpotlight && /*#__PURE__*/_jsxs(Tabs, {
      defaultSelected: defaultTab,
      onSelectedChange: e => {
        params.set('tab', e.target.value, {
          historyMethod: 'replace'
        });
      },
      children: [/*#__PURE__*/_jsx(Tab, {
        tabId: "products",
        title: unescapedText('marketplaceStorefront.searchTab.products')
      }), /*#__PURE__*/_jsx(Tab, {
        tabId: "solutionsPartners",
        title: unescapedText('marketplaceStorefront.searchTab.solutionsPartners')
      })]
    })]
  });
}